

export type RejectionsTypesValues = 'C' | 'D';

export enum REJECTIONS_TYPES_VALUES {
    CREDITO = 'C',
    DEBITO = 'D',
}